import { render, staticRenderFns } from "./DesignPackageComponent.vue?vue&type=template&id=033d523d&scoped=true"
import script from "./DesignPackageComponent.vue?vue&type=script&lang=ts"
export * from "./DesignPackageComponent.vue?vue&type=script&lang=ts"
import style0 from "./DesignPackageComponent.vue?vue&type=style&index=0&id=033d523d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033d523d",
  null
  
)

export default component.exports